import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyD8DZsUirBuvR8ZAezYTt6Qa-HNEfDJltY",
  authDomain: "lead-management-system-7bd79.firebaseapp.com",
  projectId: "lead-management-system-7bd79",
  storageBucket: "lead-management-system-7bd79.firebasestorage.app",
  messagingSenderId: "716032027963",
  appId: "1:716032027963:web:aace6a29118f2849e21b1e",
  measurementId: "G-VEKRLVKN04",
};

// Firebase Initialize
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Notification permission & token request
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BGhiAw64S2CIz3xHHSOAlx51xQD5qptx3Q4Nkn4nvddSjrqnf9kICTnGXqKMdHmZcnJyUGhpNKZUycHidedW6BI",
      });
      // console.log("FCM Token:", token);
      return token;
    } else {
      console.log("Permission denied");
    }
  } catch (error) {
    console.error("Error getting token:", error);
  }
};

// Handle foreground notifications
onMessage(messaging, (payload) => {
  if (Notification.permission === "granted") {
    new Notification(payload.notification.title, {
      body: payload.notification.body,
      icon: "/firebase-logo.png",
      data: {
        url:
          payload.data?.link ||
          "https://propertysolutions.amvuedigitalacademy.in/",
      },
    });
  }
});
